// 版本管理 API 服务
import request from '@/api/request'
import type { VersionInfo, CurrentVersionInfo } from '@/types/version'

/**
 * 获取最新版本信息
 * @param environment 环境 (prod/dev)
 * @returns 版本信息
 */
export async function getLatestVersion(environment: string): Promise<VersionInfo> {
  const data = await request.get<VersionInfo, VersionInfo>('/version/latest', {
    params: { environment },
  })
  return data
}

/**
 * 获取当前应用版本信息（从version.json读取）
 * @returns 当前版本信息
 */
export async function getCurrentVersion(): Promise<CurrentVersionInfo> {
  const data = await request.get<CurrentVersionInfo, CurrentVersionInfo>('/version/current')
  return data
}
